import styled from 'styled-components'

function BaseKeyboardArrowDownIcon({ className, size = 24, ...rest }: IconComponentProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z" fill="currentColor" />
    </svg>
  )
}

export const KeyboardArrowDownIcon = styled(BaseKeyboardArrowDownIcon)`
  flex-shrink: 0;
`
